<template>
	<span v-html="iconHTML(icon)" :title="title" @click="$emit('click')"></span>
</template>

<script>

export default {
	props: ['icon', 'title'],

	methods: {
		iconHTML(icon) {
			return require('../../images/icons/' + icon + '.svg')
		}
	}

}
</script>
